<template>
	<div class="customer-container">
		<b-container fluid>
			<div class="main-content">
				<b-row>
					<b-col md="3" class="text-center">
						<div class="avatar">
							<Avatar :avatar="avatar"/>
						</div>
					</b-col>
					<b-col md="5">
						<h2>{{ invalid ? 'Login' : ('Hallo ' + firstName + '!') }}</h2>
						<div v-if="invalid">
							<p>Offensichtlich wurde der Link schon verwendet, um deine Erst-Anmeldung abzuschließen.</p>
							<p>Melde dich bitte an:</p>
							<b-row>
								<b-col md="6">
									<Login/>
								</b-col>
							</b-row>
						</div>
						<template v-else>
							<p>
								Hier kannst du dir ein Passwort für skilldoo setzen.
							</p>
							<div class="tag-sections">
								<section class="tag">
									<h2>Dein Passwort</h2>
									<Password v-model="password"/>
								</section>
								<section class="tag">
									<PrivacyCheckbox v-model="privacy"/>
								</section>
								<section class="tag">
									<Button
										text="Passwort speichern"
										icon="checkmark"
										:disabled="!dataValid || confirming"
										:loading="confirming"
										@click="confirm"
									/>
								</section>
							</div>
							<Features class="mt-5"/>
						</template>
					</b-col>
				</b-row>
			</div>
		</b-container>
	</div>
</template>
<script>
import Avatar, {CLIPBOARD} from "@/vue/common/image/Avatar.vue";
import Password from "@/vue/common/form/Password.vue";
import {isDefined} from "@/helper/Value";
import PrivacyCheckbox from "@/vue/common/PrivacyCheckbox.vue";
import Button from "@/vue/common/Button.vue";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Confirm from "@/api/customer/confirmation/Confirm";
import Features from "@/vue/customer/Features.vue";
import {redirect} from "@/helper/Window";
import Login from "@/vue/auth/Login.vue";

export default {

	components: {Login, Features, Button, PrivacyCheckbox, Password, Avatar},

	props: {
		linkId: {
			type: String,
			required: true,
		},
		invalid: {
			type: Boolean,
			required: true,
		},
		email: {
			type: String,
			required: false,
		},
		firstName: {
			type: String,
			required: false,
		},
	},

	mounted ()
	{
	},

	data ()
	{
		return {
			password: undefined,
			privacy: false,
			confirming: false,
		};
	},

	computed: {
		avatar ()
		{
			return CLIPBOARD;
		},
		passwordValid ()
		{
			return isDefined(this.password);
		},
		privacyValid ()
		{
			return this.privacy === true;
		},
		dataValid ()
		{
			return this.passwordValid && this.privacyValid;
		}
	},

	methods: {
		async confirm ()
		{
			this.confirming = true;

			try
			{
				await new Confirm()
					.setLinkId(this.linkId)
					.setPassword(this.password)
					.call();

				redirect('/kundenbereich/jobs');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.confirming = false;
		}
	}
}
</script>
